import { isBridgeReviewUnfinished } from './case-visibility';
import { MedicareBridgeCaseView } from './medicare-bridge.types';
import { outstandingRequirementLabels } from './outstanding-requirements';
import { medicareBridgeRouteLabel } from './route-label';

export function medicareBridgeNextAction(
  bridgeCase: MedicareBridgeCaseView,
): string | null {
  // A needs-info review still stores a next route, because every non-eligible
  // decision has to name one. That route is the later handoff.
  // The current action is to finish the review, which a closed case cannot
  // take, nor any case while the platform has reviews switched off.
  if (isBridgeReviewUnfinished(bridgeCase.eligibilityReview)) {
    return bridgeCase.status === 'OPEN' && bridgeCase.reviewSubmissionEnabled
      ? 'Complete the Bridge review'
      : null;
  }
  if (bridgeCase.eligibilityReview !== 'NOT_ELIGIBLE') return null;

  return medicareBridgeRouteLabel(
    bridgeCase.latestReview?.nextRoute,
    bridgeCase.latestReview?.checklist.nextRoutes,
    bridgeCase.checklist.nextRoutes,
  );
}

/** Outstanding checklist items and the next action. Shared by prep, the visit, and follow-up. */
export function MedicareBridgeRequirements({
  bridgeCase,
  hideRouteAction = false,
}: {
  bridgeCase: MedicareBridgeCaseView;
  /** The follow-up work state already shows the operational next action. */
  hideRouteAction?: boolean;
}) {
  const labels = outstandingRequirementLabels(
    bridgeCase.checklist.items,
    bridgeCase.outstandingRequirements,
  );
  const nextAction = medicareBridgeNextAction(bridgeCase);

  return (
    <div className="flex flex-col gap-2" data-testid="medicare-bridge-requirements">
      {labels.length === 0 ? (
        <p className="text-sm text-foreground">No outstanding requirements.</p>
      ) : (
        <ul className="list-disc pl-5 text-sm text-foreground">
          {labels.map((item) => (
            <li key={item.key}>{item.label}</li>
          ))}
        </ul>
      )}
      {nextAction && !hideRouteAction ? (
        <p className="text-sm text-foreground">Next action: {nextAction}</p>
      ) : null}
    </div>
  );
}
